

export function parsePositionNumber(positionString: string): string | null {
    const match = positionString.match(/[Pp]os ?(\d+(\.\d+)?).*?/);
    return match ? match[1] : null;
}
